/**
 * The colours a learner may give a course (#436): identifier colours, muted, never a status.
 * A course colour says which course something belongs to; it never says how the learner is doing.
 * Hand-authored, not generated: `schemas/course-update-request.json` lists the same keys, and
 * `course-palette.test.ts` fails if the two drift.
 */
export const COURSE_PALETTE = ['slate', 'teal', 'plum', 'ochre', 'moss', 'rose'] as const;

export type PaletteKey = (typeof COURSE_PALETTE)[number];

/**
 * The order an unchosen course is coloured in (#648): the first course is ochre, then teal and plum, as the UX
 * canvas draws a learner's three courses. `COURSE_PALETTE`'s own order stays the picker's order.
 */
export const DEFAULT_COURSE_COLOURS: readonly PaletteKey[] = ['ochre', 'teal', 'plum', 'rose', 'moss', 'slate'];
